module.exports = __webpack_public_path__ + "static/Eight-231c84765a3617075fc0a60fee72c1c7.jpg";